import SubtleBadge from "components/common/SubtleBadge";
import classNames from "classnames";
import countries from "data/countries";
import { useFetchCostCenter } from "hooks/useFetchCostCenter";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ActionButton from "components/common/ActionButton";
import MultiSelect from "components/common/MultiSelect";
import debounce from "lodash.debounce";
import Select from "react-select";
import { SearchAccountAPI } from "api";
import { useSettingContext } from "context/SettingContext";
import { useFetchFinanceBook } from "hooks/useFetchFinanceBook";

const types = [
  "Journal",
  "Inter-Company",
  "Bank Payment",
  "Bank Receipt",
  "Cash Payment",
  "Cash Receipt",
  "Credit Card",
  "Debit Note",
  "Credit Note",
  "Contra",
  "Bad Debts / Write Offs",
  "Opening Balance",
  "Depreciation",
  "Exchange Rate Revaluation",
];

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: "10px",
          // paddingTop: "15px",
        }}
      >
        ☰
      </td>
      {children}
    </tr>
  );
};

// const AsyncSelectField = ({
//   control,
//   placeholder,
//   index,
//   name,
//   type,
//   errors,
//   costCenterId,
// }) => {
//   const [options, setOptions] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       cursor: "pointer",
//       borderColor: "#dbdbdb",
//       // width: "250px",
//     }),
//     input: (provided) => ({
//       ...provided,
//       color: "black",
//       // paddingTop: "4px",
//       // paddingBottom: "4px",
//     }),

//     menu: (provided) => ({
//       ...provided,
//       // height: 140,
//       color: "black",
//       zIndex: 2, // High enough to ensure visibility
//     }),
//     menuList: (provided) => ({
//       ...provided,
//       padding: 0,
//       // height: 140,
//       zIndex: 1, // High enough to ensure visibility
//     }),
//     menuPortal: (provided) => ({
//       ...provided,
//       zIndex: 9999,
//     }),
//   };

//   console.log("options", options);

//   const fetchOptions = async (query, type) => {
//     if (!query) return [];
//     try {
//       const response = await SearchAccountAPI.get({
//         params: { costCenterId: costCenterId, searchString: query },
//       });
//       console.log(response?.data?.data);
//       // const response = await SearchAccountAPI.get(`/api/${type}?search=${query}`);
//       return response?.data?.data?.map((item) => ({
//         label: item.title,
//         value: item.id,
//       })); // Adjust based on API response
//     } catch (error) {
//       console.error(`Error fetching ${type}:`, error);
//       return [];
//     }
//   };

//   const loadOptions = debounce(async (inputValue) => {
//     console.log(inputValue);
//     if (inputValue.length < 3) {
//       setOptions([]); // Clear options if less than 3 characters
//       return;
//     }
//     setLoading(true);
//     const data = await fetchOptions(inputValue, type);
//     console.log("data", data);
//     setOptions(data);
//     setLoading(false);
//   }, 500);

//   return (
//     <Controller
//       name={`entries[${index}].${name}`}
//       control={control}
//       render={({ field }) => (
//         <Select
//           {...field}
//           menuPortalTarget={document.body}
//           options={options}
//           isLoading={loading}
//           onInputChange={loadOptions}
//           placeholder={placeholder}
//           styles={customStyles}
//           isClearable
//         />
//       )}
//     />
//   );
// };

// const AsyncSelectField = ({
//   control,
//   placeholder,
//   index,
//   name,
//   type,
//   errors,
//   costCenterId,
// }) => {
//   const [options, setOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selected, setSelected] = useState(null);

//   // console.log("errors", errors);

//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       cursor: "pointer",
//       borderColor: errors?.entries?.[index]?.accountId ? "#dc3545" : "#dbdbdb",
//       "&:hover": {
//         borderColor: errors?.entries?.[index]?.accountId
//           ? "#dc3545"
//           : "#dbdbdb",
//       },
//       boxShadow:
//         state.isFocused && !errors?.entries?.[index]?.accountId
//           ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
//           : "none",
//     }),
//     input: (provided) => ({
//       ...provided,
//       color: "black",
//     }),
//     menu: (provided) => ({
//       ...provided,
//       color: "black",
//       zIndex: 2,
//     }),
//     menuList: (provided) => ({
//       ...provided,
//       padding: 0,
//       zIndex: 1,
//     }),
//     menuPortal: (provided) => ({
//       ...provided,
//       zIndex: 9999,
//     }),
//   };

//   // console.log("Current Options:", options); // Debugging: Check if options are updating

//   const fetchOptions = async (query) => {
//     if (!query) return [];
//     try {
//       const response = await SearchAccountAPI.get({
//         params: { costCenterId: costCenterId, searchString: query },
//       });

//       // console.log("API Response:", response?.data?.data);
//       return response?.data?.data || []; // Ensure response is an array
//     } catch (error) {
//       console.error("Error fetching options:", error);
//       return [];
//     }
//   };

//   const loadOptions = debounce(async (inputValue) => {
//     if (inputValue.length < 3) {
//       setOptions([]); // Clear options if input length is less than 3
//       return;
//     }

//     setLoading(true);
//     const data = await fetchOptions(inputValue);
//     // console.log("Fetched Data:", data);
//     setOptions(data);
//     setLoading(false);
//   }, 500);

//   return (
//     <Controller
//       name={`entries[${index}].${name}`}
//       control={control}
//       render={({ field }) => {
//         // Ensure selected option persists even when options disappear
//         const selectedOption =
//           options.find((option) => option.id === field.value) || selected;

//         const error = errors?.entries?.[index]?.accountId;

//         return (
//           <>
//             <Select
//               {...field}
//               className={classNames({
//                 "is-invalid": error,
//               })}
//               menuPortalTarget={document.body}
//               options={options}
//               isLoading={loading}
//               getOptionLabel={(option) => option.title} // Display title
//               getOptionValue={(option) => option.id} // Store ID in state
//               onInputChange={(input) => {
//                 loadOptions(input);
//                 return input;
//               }}
//               onChange={(selectedOption) => {
//                 // console.log("Selected Option:", selectedOption);
//                 setSelected(selectedOption); // Persist selected option
//                 field.onChange(selectedOption?.id); // Store only ID
//               }}
//               value={selectedOption} // Keep selected option even when options disappear
//               placeholder={placeholder}
//               styles={customStyles}
//               isClearable
//             />
//             {error && (
//               <div className="invalid-feedback" style={{ display: "block" }}>
//                 {error.message}
//               </div>
//             )}
//           </>
//         );
//       }}
//     />
//   );
// };

// const AsyncSelectField = ({
//   control,
//   placeholder,
//   index,
//   name,
//   type,
//   errors,
//   costCenterId,
//   defaultValue,
// }) => {
//   const [options, setOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selected, setSelected] = useState(null);

//   console.log("selected", selected);

//   // console.log(defaultValue);
//   // ✅ Hook to initialize selected value once
//   useEffect(() => {
//     if (defaultValue && !selected) {
//       setSelected(defaultValue);
//     }
//   }, [defaultValue]);

//   const customStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       cursor: "pointer",
//       borderColor: errors?.entries?.[index]?.accountId ? "#dc3545" : "#dbdbdb",
//       "&:hover": {
//         borderColor: errors?.entries?.[index]?.accountId
//           ? "#dc3545"
//           : "#dbdbdb",
//       },
//       boxShadow:
//         state.isFocused && !errors?.entries?.[index]?.accountId
//           ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
//           : "none",
//     }),
//     input: (provided) => ({ ...provided, color: "black" }),
//     menu: (provided) => ({ ...provided, color: "black", zIndex: 2 }),
//     menuList: (provided) => ({ ...provided, padding: 0, zIndex: 1 }),
//     menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   const fetchOptions = async (query) => {
//     if (!query) return [];
//     try {
//       const response = await SearchAccountAPI.get({
//         params: { costCenterId: costCenterId, searchString: query },
//       });
//       return response?.data?.data || [];
//     } catch (error) {
//       console.error("Error fetching options:", error);
//       return [];
//     }
//   };

//   const loadOptions = debounce(async (inputValue) => {
//     if (inputValue.length < 3) {
//       setOptions([]);
//       return;
//     }

//     setLoading(true);
//     const data = await fetchOptions(inputValue);
//     setOptions(data);
//     setLoading(false);
//   }, 500);

//   return (
//     <Controller
//       name={`entries[${index}].${name}`}
//       control={control}
//       render={({ field }) => {
//         const error = errors?.entries?.[index]?.accountId;
//         const selectedOption =
//           options.find((option) => option.id === field.value) || selected;

//         console.log(selectedOption);

//         return (
//           <>
//             <Select
//               {...field}
//               className={classNames({ "is-invalid": error })}
//               menuPortalTarget={document.body}
//               options={options}
//               isLoading={loading}
//               getOptionLabel={(option) => option.title}
//               getOptionValue={(option) => option.id}
//               onInputChange={(input) => {
//                 loadOptions(input);
//                 return input;
//               }}
//               onChange={(selectedOption) => {
//                 setSelected(selectedOption);
//                 field.onChange(selectedOption?.id); // post only ID
//               }}
//               value={selectedOption}
//               placeholder={placeholder}
//               styles={customStyles}
//               isClearable
//             />
//             {error && (
//               <div className="invalid-feedback" style={{ display: "block" }}>
//                 {error.message}
//               </div>
//             )}
//           </>
//         );
//       }}
//     />
//   );
// };

const AsyncSelectField = ({
  control,
  placeholder,
  index,
  name,
  type,
  errors,
  costCenterId,
  defaultValue,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(defaultValue || null); // Initialize with defaultValue

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      borderColor: errors?.entries?.[index]?.accountId ? "#dc3545" : "#dbdbdb",
      "&:hover": {
        borderColor: errors?.entries?.[index]?.accountId
          ? "#dc3545"
          : "#dbdbdb",
      },
      boxShadow:
        state.isFocused && !errors?.entries?.[index]?.accountId
          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
          : "none",
    }),
    input: (provided) => ({ ...provided, color: "black" }),
    menu: (provided) => ({ ...provided, color: "black", zIndex: 2 }),
    menuList: (provided) => ({ ...provided, padding: 0, zIndex: 1 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const fetchOptions = async (query) => {
    if (!query) return [];
    try {
      const response = await SearchAccountAPI.get({
        params: { costCenterId: costCenterId, searchString: query },
      });
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const loadOptions = debounce(async (inputValue) => {
    if (inputValue.length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);
    const data = await fetchOptions(inputValue);
    setOptions(data);
    setLoading(false);
  }, 500);

  return (
    <Controller
      name={`entries[${index}].${name}`}
      control={control}
      defaultValue={defaultValue?.id || null} // Set default value for the form
      render={({ field }) => {
        const error = errors?.entries?.[index]?.accountId;
        const selectedOption =
          options.find((option) => option.id === field.value) || selected;

        return (
          <>
            <Select
              {...field}
              className={classNames({ "is-invalid": error })}
              menuPortalTarget={document.body}
              options={options}
              isLoading={loading}
              getOptionLabel={(option) => option.title}
              getOptionValue={(option) => option.id}
              onInputChange={(input) => {
                loadOptions(input);
                return input;
              }}
              onChange={(selectedOption) => {
                setSelected(selectedOption || null); // Update selected state
                field.onChange(selectedOption?.id || null); // Clear form value when null
              }}
              value={selectedOption}
              placeholder={placeholder}
              styles={customStyles}
              isClearable
            />
            {error && (
              <div className="invalid-feedback" style={{ display: "block" }}>
                {error.message}
              </div>
            )}
          </>
        );
      }}
    />
  );
};

const VoucherBasicInformation = ({ apiLoading }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    clearErrors,
    control,
    watch,
    dirtyFields,
    formState: { errors },
  } = useFormContext();

  const {
    fields: entries,
    append: appendDetails,
    remove: removeDetails,
    move,
  } = useFieldArray({
    control,
    name: "items",
  });

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;
  // const { data, isLoading } = useFetchCostCenter();
  // let costCenter = data?.data?.data;

  const settingsData = useSettingContext();
  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );
  const costCenterId = Number(costCenter?.value) || 1; // Ensure it's a number

  const { data, isLoading: financeBookLoading } =
    useFetchFinanceBook(costCenterId);
  const fiananceBooks = data?.data?.data?.map((d) => ({
    label: d.name,
    value: d.id,
  }));

  // console.log(fiananceBooks);

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = entries.findIndex((item) => item.id === active.id);
      const newIndex = entries.findIndex((item) => item.id === over.id);
      move(oldIndex, newIndex);
    }
  };
  const entriesWatch = useWatch({ control, name: "items" }) || []; // Tracks changes in real-time

  const handleDebitChange = (index, value) => {
    setValue(`entries.${index}.debit`, value);
    if (value > 0) setValue(`entries.${index}.credit`, ""); // Clear Credit
  };

  // Function to clear Debit when Credit is entered
  const handleCreditChange = (index, value) => {
    setValue(`entries.${index}.credit`, value);
    if (value > 0) setValue(`entries.${index}.debit`, ""); // Clear Debit
  };

  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  useEffect(() => {
    // console.log("Updated entries:", entriesWatch); // Debugging log

    const debitSum = entriesWatch.reduce(
      (sum, item) => sum + (parseFloat(item.debit) || 0),
      0
    );
    setTotalDebit(debitSum);

    const creditSum = entriesWatch.reduce(
      (sum, item) => sum + (parseFloat(item.credit) || 0),
      0
    );
    setTotalCredit(creditSum);
  }, [entriesWatch]); // ✅ Updates immediately when input changes

  return (
    <>
      {apiLoading || loading || financeBookLoading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 8rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="type"
                  type="text"
                  title="Type"
                  className="py-2"
                  isInvalid={!!errors?.type}
                  {...register("type")}
                >
                  <option value="">Select Type</option>
                  {types.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.type?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Number"
                  title="Number"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.number}
                  {...register("number")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.number?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            {/* <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="costCenter"
                  type="text"
                  title="Cost Center"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.costCenterId}
                  {...register("costCenterId")}
                >
                  <option value="">Select Cost Center</option>
                  {costCenter?.map((item, index) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.costCenterId?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> */}
            <Col md="6">
              {/* <Form.Group>
                <Form.Select
                  aria-label="financeBook"
                  type="text"
                  title="Finance Book"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.financeBook}
                  {...register("financeBook")}
                >
                  <option value="">Select Finance Book</option>

                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.financeBook?.message}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group>
                <Controller
                  name="fiananceBooks"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      placeholder="Select Finance Book"
                      closeMenuOnSelect={false}
                      isMulti
                      styles={{
                        placeholder: (provided) => ({
                          ...provided,
                          paddingTop: "7px",
                          paddingBottom: "7px",
                        }),
                      }}
                      options={fiananceBooks}
                      // value={fiananceBooks?.filter((book) =>
                      //   field?.value?.some(
                      //     (selected) => selected?.value === book.value
                      //   )
                      // )}
                      onChange={(selected) => field.onChange(selected)}
                      className={classNames({
                        "is-invalid": errors.fiananceBooks,
                      })}
                    />
                  )}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.fiananceBooks?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Date"
                  title="Date"
                  className="py-2 mb-1"
                  isInvalid={!!errors.date}
                  {...register("date")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.date?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Posting Date"
                  title="Posting Date"
                  className="py-2 mb-1"
                  isInvalid={!!errors.postingDate}
                  {...register("postingDate")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.postingDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Check
                type="checkbox"
                id="defaultSwitch"
                label="Active"
                className="mt-2"
                defaultChecked={!state}
                isInvalid={!!errors.status}
                {...register("status")}
              />
            </Col>

            <Row className="gx-2">
              <DndContext
                sensors={sensors}
                collisionDetection={closestCorners}
                onDragEnd={handleDragEnd}
              >
                <SortableContext
                  items={entries.map((item) => item.id)}
                  strategy={verticalListSortingStrategy}
                >
                  <div
                    style={{
                      maxHeight: `calc(100vh - 20.7rem)`,
                      overflowY: "auto",
                      // border: "1px solid #ddd",
                    }}
                  >
                    <Table
                      className=""
                      style={{ borderCollapse: "separate", borderSpacing: 0 }}
                    >
                      {/* 🔹 Fixed Header */}
                      <thead
                        className="bg-200"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 10,
                          background: "#fff",
                        }}
                      >
                        <tr>
                          <th
                            scope="col"
                            className="w-0 fs-10 text-center"
                          ></th>
                          <th
                            scope="col"
                            className="fs-10 text-center"
                            style={{ width: "140px" }}
                          >
                            Line Number
                          </th>
                          <th scope="col" className="fs-10">
                            Account
                          </th>
                          <th scope="col" className="fs-10">
                            Sub Ledger
                          </th>
                          <th scope="col" className="fs-10">
                            Description
                          </th>
                          <th
                            scope="col"
                            className="fs-10 text-end"
                            style={{ width: "180px" }}
                          >
                            Debit
                          </th>
                          <th
                            scope="col"
                            className="fs-10 text-end"
                            style={{ width: "180px" }}
                          >
                            Credit
                          </th>
                          <th
                            scope="col"
                            style={{ padding: "9px", width: "10px" }}
                            className="text-end"
                          >
                            <ActionButton
                              icon="plus"
                              variant="success"
                              title="Add"
                              className="px-1 py-0"
                              onClick={() => appendDetails({})}
                            />
                          </th>
                        </tr>
                      </thead>

                      {/* 🔹 Scrollable Table Body */}
                      <tbody>
                        {entries.map((item, index) => (
                          <SortableItem key={item.id} id={item.id}>
                            <td className="text-center">{index + 1}</td>
                            <td style={{ padding: "10px" }}>
                              {/* <AsyncSelectField
                                control={control}
                                costCenterId={costCenterId}
                                index={index}
                                name="accountId"
                                type="accounts"
                                placeholder="Account"
                                errors={errors}
                              /> */}

                              <AsyncSelectField
                                control={control}
                                costCenterId={costCenterId}
                                index={index}
                                name="accountId"
                                type="accounts"
                                placeholder="Account"
                                errors={errors}
                                defaultValue={
                                  state
                                    ? {
                                        id: item.accountId,
                                        title: item.accountTitle,
                                      }
                                    : null
                                }
                              />
                            </td>

                            <td style={{ padding: "10px" }}>
                              <Form.Control
                                type="text"
                                placeholder="Sub Ledger"
                                isInvalid={
                                  !!errors.entries?.[index]?.subLedgerName
                                }
                                {...register(`entries[${index}].subLedgerName`)}
                              />
                              <Form.Control.Feedback type="invalid">
                                {
                                  errors.entries?.[index]?.subLedgerName
                                    ?.message
                                }
                              </Form.Control.Feedback>
                            </td>
                            <td style={{ padding: "10px" }}>
                              <Form.Control
                                type="text"
                                placeholder="Description"
                                isInvalid={
                                  !!errors.entries?.[index]?.description
                                }
                                {...register(`entries[${index}].description`)}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.entries?.[index]?.description?.message}
                              </Form.Control.Feedback>
                            </td>
                            <td style={{ paddingTop: "10px" }}>
                              <Form.Control
                                type="number"
                                placeholder="Debit"
                                className="text-end"
                                isInvalid={!!errors.entries?.[index]?.debit}
                                {...register(`entries[${index}].debit`)}
                                onChange={(e) =>
                                  handleDebitChange(index, e.target.value)
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.entries?.[index]?.debit?.message}
                              </Form.Control.Feedback>
                            </td>
                            <td style={{ paddingTop: "10px" }}>
                              <Form.Control
                                type="number"
                                placeholder="Credit"
                                className="text-end"
                                isInvalid={!!errors.entries?.[index]?.credit}
                                {...register(`entries[${index}].credit`)}
                                onChange={(e) =>
                                  handleCreditChange(index, e.target.value)
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.entries?.[index]?.credit?.message}
                              </Form.Control.Feedback>
                            </td>
                            <td
                              style={{ paddingLeft: "9px", maxWidth: "10px" }}
                              className="text-center"
                            >
                              <ActionButton
                                icon="trash-alt"
                                title="Delete"
                                variant="danger"
                                className="px-1 py-0"
                                onClick={() => removeDetails(index)}
                              />
                            </td>
                          </SortableItem>
                        ))}
                      </tbody>

                      {/* 🔹 Fixed Footer */}
                      <tfoot
                        style={{
                          position: "sticky",
                          bottom: 0,
                          zIndex: 10,
                          background: "#fff",
                        }}
                      >
                        <tr>
                          <th
                            scope="col"
                            className="w-0 fs-10 text-center"
                          ></th>
                          <th
                            scope="col"
                            className="fs-10 text-center"
                            style={{ width: "140px" }}
                          ></th>
                          <th scope="col" className="fs-10"></th>
                          <th scope="col" className="fs-10"></th>
                          <th scope="col" className="fs-10 fw-bold">
                            Total
                          </th>
                          <th
                            scope="col"
                            className="fs-10 text-end  fw-bold"
                            style={{ width: "180px" }}
                          >
                            Rs. {totalDebit.toFixed(2)}
                          </th>
                          <th
                            scope="col"
                            className="fs-10 text-end  fw-bold"
                            style={{ width: "180px" }}
                          >
                            Rs. {totalCredit.toFixed(2)}
                          </th>
                          <th
                            scope="col"
                            style={{ padding: "9px", width: "10px" }}
                            className="text-end"
                          ></th>
                        </tr>
                        {errors.entries?.message && (
                          <tr>
                            <td colSpan="8" className="text-danger text-end">
                              {errors.entries.message}
                            </td>
                          </tr>
                        )}
                      </tfoot>
                    </Table>
                  </div>
                </SortableContext>
              </DndContext>
            </Row>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default React.memo(VoucherBasicInformation);
